var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9047 7.70722C14.7707 7.5239 11.5778 3.21875 7.49993 3.21875C3.42206 3.21875 0.229043 7.52391 0.0951857 7.70704C-0.0317286 7.88095 -0.0317286 8.11682 0.0951857 8.29072C0.229043 8.47403 3.42206 12.7792 7.49993 12.7792C11.5778 12.7792 14.7707 8.47401 14.9047 8.29087C15.0318 8.11699 15.0318 7.88095 14.9047 7.70722ZM7.49993 11.7902C4.49614 11.7902 1.89454 8.93277 1.12442 7.99863C1.89355 7.06368 4.4897 4.20776 7.49993 4.20776C10.5036 4.20776 13.105 7.06468 13.8754 7.99931C13.1063 8.93423 10.5102 11.7902 7.49993 11.7902Z",
    fill: "#151B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49976 5.03125C5.86376 5.03125 4.53271 6.3623 4.53271 7.9983C4.53271 9.6343 5.86376 10.9653 7.49976 10.9653C9.13576 10.9653 10.4668 9.6343 10.4668 7.9983C10.4668 6.3623 9.13576 5.03125 7.49976 5.03125ZM7.49976 9.97631C6.40904 9.97631 5.52175 9.08899 5.52175 7.9983C5.52175 6.9076 6.40907 6.02028 7.49976 6.02028C8.59046 6.02028 9.47777 6.9076 9.47777 7.9983C9.47777 9.08899 8.59049 9.97631 7.49976 9.97631Z",
    fill: "#151B26"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default ForwardRef;